import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./SmallRpcCourse.css";
import EnrollForm from "./EnrollForm";

import { API_BASE_URL } from "../config";

const CourseEnrollTemplate = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const getMainImage = (course) => {
    if (course?.images?.main) return course.images.main;
    if (course?.image) return course.image;
    return null;
  };

  const getGalleryImage = (course, index) => {
    if (course?.images?.gallery?.[index]) {
      return course.images.gallery[index];
    }
    return getMainImage(course); // fallback
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/courses/${id}`)
      .then((res) => res.json())
      .then((data) => setCourse(data))
      .catch((err) => console.error(err));
  }, [id]);

  if (!course) return <h2 style={{ textAlign: "center" }}>Loading...</h2>;

  return (
    <div className="course-page">
      {/* Top Section */}
      <div className="course-container">
        <div className="course-text">
          <h2>{course.name}</h2>
          <p>{course.description}</p>

          <div className="btn-group">
            <span className="price">₹{course.price}</span>
            <button className="enroll" onClick={() => setShowForm(true)}>
              ENROLL NOW
            </button>
          </div>

          <div className="info-sections">
            <div className="info-cardds">
              <span>⏱</span>
              <p>
                <b>DURATION</b>
                <br></br>
                {course.days} Days
              </p>
            </div>
            <div className="info-cardds">
              <span>💰</span>
              <p>
                <b>GST</b>
                <br></br>
                {course.gst}
              </p>
            </div>
            <div className="info-cardds">
              <span>📍</span>
              <p>
                <b>LOCATION</b>
                <br></br>
                {course.location || "Namakkal , Bangalore"}
              </p>
            </div>
          </div>
        </div>

        <div className="course-image">
          {getMainImage(course) ? (
            <img
              src={`${API_BASE_URL}${getMainImage(course)}`}
              alt={course.name}
            />
          ) : (
            <img src="/placeholder.png" alt={course} />
          )}
        </div>
      </div>
      {/* <hr /> */}
      {/* Details Section */}
      <div className="course-details">
        {/* ABOUT */}
        <div className="zigzag-row">
          <div className="zigzag-text">
            <h3>About the Course</h3>
            <p>{course.aboutCourse}</p>
          </div>

          <div className="zigzag-image">
            {getMainImage(course) && (
              <img
                src={`${API_BASE_URL}${getGalleryImage(course, 0)}`}
                alt={`${course.name} overview`}
              />
            )}
          </div>
        </div>

        {/* ELIGIBILITY */}
        <div className="zigzag-row reverse">
          <div className="zigzag-text">
            <h3>Eligibility</h3>
            <ul>
              {(Array.isArray(course.eligibility)
                ? course.eligibility
                : course.eligibility?.split(",") || []
              ).map((item, i) => (
                <li key={i}>{item.trim()}</li>
              ))}
            </ul>
          </div>

          <div className="zigzag-image">
            {getMainImage(course) && (
              <img
                src={`${API_BASE_URL}${getGalleryImage(course, 1)}`}
                alt={`${course.name} overview`}
              />
            )}
          </div>
        </div>

        {/* INCLUDES */}
        <div className="zigzag-row">
          <div className="zigzag-text">
            <h3>This Course Includes</h3>
            <ul>
              {(Array.isArray(course.courseIncludes)
                ? course.courseIncludes
                : course.courseIncludes?.split(",") || []
              ).map((item, i) => (
                <li key={i}>{item.trim()}</li>
              ))}
            </ul>
          </div>

          <div className="zigzag-image">
            {getMainImage(course) && (
              <img
                src={`${API_BASE_URL}${getGalleryImage(course, 2)}`}
                alt={`${course.name} overview`}
              />
            )}
          </div>
        </div>

        {/* EXCLUDES */}
        <div className="zigzag-row reverse">
          <div className="zigzag-text">
            <h3>This Course Excludes</h3>
            <ul>
              {(Array.isArray(course.courseExcludes)
                ? course.courseExcludes
                : course.courseExcludes?.split(",") || []
              ).map((item, i) => (
                <li key={i}>{item.trim()}</li>
              ))}
            </ul>
          </div>

          <div className="zigzag-image">
            {getMainImage(course) && (
              <img
                src={`${API_BASE_URL}${getGalleryImage(course, 3)}`}
                alt={`${course.name} overview`}
              />
            )}
          </div>
        </div>
      </div>

      {/* Enroll Form Popup */}
      {/* {showForm && (
        <EnrollForm
          course={course.name}
          onClose={() => setShowForm(false)}
        />
      )} */}
      {/* Enroll Form Popup */}
      {showForm && (
        <EnrollForm
          course={course} // pass full course object instead of course.name
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default CourseEnrollTemplate;
